import { render } from "./PokemonPicture.vue?vue&type=template&id=018a83ef"
import script from "./PokemonPicture.vue?vue&type=script&lang=js"
export * from "./PokemonPicture.vue?vue&type=script&lang=js"

import "./PokemonPicture.vue?vue&type=style&index=0&id=018a83ef&scope=true&lang=css"

import exportComponent from "C:\\PRACTICA\\04pokemon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__